import { db, FirebaseDocRefType } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { PointCardType as BasicPointCardType } from 'types/pointCard'

type PointCardType = BasicPointCardType & { ref: FirebaseDocRefType }

const PointCardConverter = getConverter<PointCardType>()

export const fetchPointCard = (id: string): Promise<PointCardType | undefined> => {
  return db
    .collection('point_cards')
    .doc(id)
    .withConverter(PointCardConverter)
    .get()
    .then((snapshot) => {
      const data = snapshot.data()
      if (!data) {
        return undefined
      }
      return {
        ...data,
        ref: snapshot.ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchPointCardByBrandRef = (brandRef: FirebaseDocRefType): Promise<PointCardType | undefined> => {
  return db
    .collection('point_cards')
    .withConverter(PointCardConverter)
    .where('brand_ref', '==', brandRef)
    .get()
    .then((snapshots) => {
      const snapshot = snapshots.docs.filter((snapshot) => snapshot.data().status !== 'deleted')
      if (snapshot.length === 0) {
        return undefined
      }
      const data = snapshot[0].data()
      return {
        ...data,
        ref: snapshot[0].ref,
      }
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const setPointCard = (pointCard: PointCardType): Promise<void> => {
  const { ref, ...rest } = pointCard
  return ref.set(rest, { merge: true })
}
